module.exports = __webpack_public_path__ + "img/support_c6.b45f7d0e.png";